// extracted by mini-css-extract-plugin
export default {"row":"LayoutNarrowView_row__eA7qM"};